import React, { useEffect, useState } from 'react';
import useRekognition from './hooks/useRekognition';
import {
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '@/src/shadComponents/ui/card';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';

interface RekognitionLabelsProps {
    activationId: number;
}

interface Label {
    id: number;
    mediaId: number;
    label: string;
    createdAt: string;
}

export default function RekognitionLabels({
    activationId,
}: RekognitionLabelsProps) {
    const rekognition = useRekognition();
    const [labels, setLabels] = useState<Label[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadLabels();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId]);

    const loadLabels = async () => {
        try {
            const response = await rekognition.getLabels(activationId);
            setLabels(response.data);
        } catch (error) {
            console.error('Error loading labels:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <CardHeader>
                <CardTitle>Results</CardTitle>
                <CardDescription>
                    View all recognized items for this activation
                </CardDescription>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Media ID</TableHead>
                            <TableHead>Label</TableHead>
                            <TableHead>Created At</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {labels.map((label) => (
                            <TableRow key={label.id}>
                                <TableCell>{label.mediaId}</TableCell>
                                <TableCell>{label.label}</TableCell>
                                <TableCell>
                                    {new Date(label.createdAt).toLocaleString()}
                                </TableCell>
                            </TableRow>
                        ))}
                        {labels.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} className="text-center">
                                    Nothing detected
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </CardContent>
        </div>
    );
}
